"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StrategyMatrixSkeletonGrid = exports.StrategyMatrixSkeletonSelectors = exports.StrategyMatrixSkeletonWrapper = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
const PAGE_TITLE = '7vh';
const FILTER_SECTION = '18vh';
exports.StrategyMatrixSkeletonWrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1)};
`;
exports.StrategyMatrixSkeletonSelectors = styled_components_1.default.div `
  display: flex;
  gap: ${({ theme }) => theme.spacing(1)};
  background: ${ui_components_1.baseColors.white};
  padding: ${({ theme }) => theme.spacing(1, 1.5)};
`;
exports.StrategyMatrixSkeletonGrid = styled_components_1.default.div `
  display: grid;
  grid-template-columns: 180px 200px repeat(4, minmax(120px, 1fr));
  gap: 1px;
  height: calc(100vh - ${PAGE_TITLE} - ${FILTER_SECTION});
  overflow: hidden;
`;
